import { Button } from "@mui/material";
import React from "react";
import colors from "../../theme/themeConstants";

interface IProps {
  img?: string;
  imgSize: string;
  width?: number;
  height?: number;
  bgColor?: string;
  onClick?: ((event: React.MouseEvent) => void) | ((prop: any) => void);
}

const DEFAULT_SIZE = 32;

const RoundButton = ({ img, imgSize, width = DEFAULT_SIZE, height = DEFAULT_SIZE, bgColor, onClick }: IProps) => {
  return (
    <Button onClick={onClick} sx={{
      backgroundColor: bgColor ? bgColor : colors.redPink,
      height: height || "32px",
      width: width || "32px",
      minWidth: width || "unset",
      border: img ? "none" : `1px solid ${colors.redPink}`,
      borderRadius: "50%",
      "&:hover": {
        backgroundColor: bgColor ? bgColor : colors.redPink,
      },
      "& img": {
        minHeight: "unset",
        width: imgSize,
      }
    }}>
      {img ? <img src={img} alt="" /> : null}
    </Button>
  );
};

export default RoundButton;
